import { buildPageCanonicalUrl } from './pageSeo';
import {
  getLaunchIndexProducts,
  getLaunchPath,
  getPrimaryLaunchProducts,
} from '../domain/seasonalLaunch';

export function buildSeasonalLaunchJsonLd(launch, origin) {
  if (!launch) return null;
  const path = getLaunchPath(launch);
  const canonical = buildPageCanonicalUrl(path, origin);
  const indexed = getLaunchIndexProducts(launch);
  const products = indexed.length ? indexed : getPrimaryLaunchProducts(launch);

  const article = {
    '@type': 'Article',
    headline: launch.pageTitle,
    description: launch.metaDescription,
    author: {
      '@type': 'Person',
      name: launch.authorName || 'Alex Timm',
    },
    publisher: {
      '@type': 'Organization',
      name: 'Angler Built',
    },
    mainEntityOfPage: canonical,
    datePublished: launch.publishedDate || launch.snapshot?.checkedOn,
  };

  const breadcrumbs = {
    '@type': 'BreadcrumbList',
    itemListElement: (launch.breadcrumbs || []).map((crumb, index) => {
      const item = {
        '@type': 'ListItem',
        position: index + 1,
        name: crumb.label,
      };
      if (crumb.path) item.item = buildPageCanonicalUrl(crumb.path, origin);
      return item;
    }),
  };

  const itemList = {
    '@type': 'ItemList',
    name: `${launch.brand} ${launch.launchSeason} new gear`,
    numberOfItems: products.length,
    itemListElement: products.map((product, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: product.name,
      url: `${canonical}#${product.id}`,
    })),
  };

  return {
    '@context': 'https://schema.org',
    '@graph': [article, breadcrumbs, itemList],
  };
}
